<template xmlns:v-popover="">
  <div>
    <el-table
        v-loading="loading"
        class="table__header-subtitles motion-schedules-setting"
        :data="formatedMotionSchedules"
        style="width: 100%"
        height="250">
      <el-table-column
          :render-header="addMotionSchedule"
          fixed="left"
          width="40"
          prop="active"
          :disabled="!allowAddMotionSchedule">
        <template slot-scope="scope">
          <font-awesome-icon
              :class="{'active-icon__color': scope.row.active, 'inactive-icon__color': !scope.row.active}"
              :icon="activeIcon" />
        </template>
      </el-table-column>
      <el-table-column
          min-width="100"
          prop="title"
          label="Name" />
      <el-table-column
          prop="time_range"
          label="Time"
          width="110">
        <template slot-scope="scope">
          <section class="time-range__column">
            <span>
              <small>From</small> <span>{{ scope.row.time_range.from }}</span>
            </span>
            <span>
              <small>To</small> <span>{{ scope.row.time_range.to }}</span>
            </span>
          </section>
        </template>
      </el-table-column>
      <el-table-column
          prop="days"
          label="Days"
          min-width="140" />
      <el-table-column
          width="30">
        <template
            slot-scope="scope">
          <font-awesome-icon
              v-acl.show="{permission: 'delete', on: 'MotionSchedule'}"
              :icon="deleteIcon"
              size="xs"
              class="delete-schedule-icon"
              @click="deleteSchedule(scope.row.id, scope.row)" />
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
        title="Add Schedule"
        :visible.sync="motionScheduleFormVisible"
        width="26%">
      <el-form
          ref="scheduleForm"
          label-position="top"
          label-width="100px"
          :rules="scheduleFormRules"
          :model="scheduleForm">
        <el-form-item
            label="Name"
            prop="name">
          <el-input v-model="scheduleForm.name" />
        </el-form-item>
        <el-form-item
            label="Days"
            prop="days">
          <el-checkbox-group
              v-model="scheduleForm.days"
              size="small">
            <el-checkbox-button
                v-for="(day, abbr) in weekDaysAbbr"
                :key="day"
                :label="abbr">
              {{ day }}
            </el-checkbox-button>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="Time">
          <el-time-picker
              v-model="scheduleForm.timeRange"
              is-range
              size="medium"
              :picker-options="{ start: '00:00', step: '00:15', end: '24:00' }"
              format="hh:mm A"
              :clearable="false"
              range-separator="To"
              start-placeholder="Start time"
              end-placeholder="End time" />
        </el-form-item>
      </el-form>
      <div style="text-align: right; margin: 0">
        <el-button
            size="mini"
            type="text"
            @click="motionScheduleFormVisible = false">
          cancel
        </el-button>
        <el-button
            type="primary"
            size="mini"
            :loading="working"
            @click="submitScheduleForm('scheduleForm')">
          confirm
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapGetters } = createNamespacedHelpers("db/device");
const { mapGetters: sharedGetters } = createNamespacedHelpers("shared");
import { keys, isEmpty, cloneDeep } from "lodash";
import { faCircle, faTrashAlt } from "@fortawesome/fontawesome-free-solid";

export default {
  name: "MotionSchedule",
  components: {},
  data() {
    return {
      deviceId: 9898,
      loading: false,
      working: false,
      formatedMotionSchedules: [],
      motionScheduleFormVisible: false,
      scheduleFormRules: {
        name: [
          {
            required: true,
            message: "Please input schedule name",
            trigger: "blur",
          },
        ],
        days: [
          {
            type: "array",
            required: true,
            message: "Please select at least one day",
            trigger: "change",
          },
        ],
      },
      scheduleForm: {
        name: null,
        days: [],
        timeRange: [
          this.$moment().hours(12).minutes(0).seconds(0),
          this.$moment().hours(12).minutes(0).seconds(0),
        ],
      },
    };
  },
  computed: {
    ...mapGetters(["motionSchedules", "weekDaysAbbr", "doorbotId", "macId"]),
    ...sharedGetters(["userHasPermission"]),
    ready() {
      return !isEmpty(this.motionSchedules);
    },
    activeIcon() {
      return faCircle;
    },
    deleteIcon() {
      return faTrashAlt;
    },
    allowAddMotionSchedule() {
      return this.userHasPermission({
        permission: "create",
        on: "MotionSchedule",
      });
    },
  },
  mounted() {
    this.reloadMotionSchedules();
  },
  methods: {
    ...mapActions([
      "fetchMotionSchedules",
      "addMotionSchedules",
      "deleteMotionSchedules",
    ]),
    reloadMotionSchedules() {
      this.loading = true;
      this.fetchMotionSchedules(this.doorbotId)
        .then(() => {
          const formatTime = (time) => {
            const paddingZeroLeft = (value) => ("0" + value).slice(-2);
            const hour = parseInt(time.split(":")[0]);
            const minute = parseInt(time.split(":")[1]);
            return (
              paddingZeroLeft(hour >= 12 ? hour - 12 : hour) +
              ":" +
              paddingZeroLeft(minute) +
              " " +
              (hour < 12 ? "AM" : "PM")
            );
          };

          this.formatedMotionSchedules = cloneDeep(this.motionSchedules);
          this.formatedMotionSchedules.forEach((ms) => {
            ms.time_range.from = formatTime(ms.time_range.from);
            ms.time_range.to = formatTime(ms.time_range.to);
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    addMotionSchedule(h) {
      if (!this.allowAddMotionSchedule) {
        return null;
      }

      const self = this;
      return h("i", {
        class: "el-icon-plus",
        style: {
          display: "block",
          color: "gray",
          fontSize: "larger",
          fontWeight: "bolder",
          verticalAlign: "sub",
          color: "#1998D5",
          cursor: "pointer",
        },
        on: {
          click() {
            self.motionScheduleFormVisible = true;
          },
        },
      });
    },
    deleteSchedule(motionScheduleId, schedule) {
      const { id, title } = schedule;
      this.working = true;
      this.deleteMotionSchedules({
        doorbotId: this.doorbotId,
        motionScheduleId: motionScheduleId,
      })
        .then(this.onSuccess(`${title} schedule deleted`))
        .catch(this.onError(`${title} schedule could not be deleted`))
        .finally(() => {
          this.working = false;
          this.reloadMotionSchedules();
        });
    },
    submitScheduleForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let [start, end] = this.scheduleForm.timeRange;
          start = this.$moment(start);
          end = this.$moment(end);
          const days = this.scheduleForm.days.reduce((daysObj, day) => {
            daysObj[day] = true;
            return daysObj;
          }, {});
          const title = this.scheduleForm.name;
          const payload = {
            id: this.doorbotId,
            motion_rule: {
              title,
              time_range: {
                start_hour: start.hours(),
                start_minute: start.minutes(),
                end_hour: end.hours(),
                end_minute: end.minutes(),
              },
              active: true,
              days,
            },
          };
          this.working = true;
          this.addMotionSchedules({ doorbotId: this.doorbotId, payload })
            .then(this.onSuccess(`${title} schedule saved`))
            .catch(this.onError(`${title} schedule could not be saved`))
            .finally(() => {
              this.working = false;
              this.motionScheduleFormVisible = false;
              this.reloadMotionSchedules();
            });
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    onSuccess(msg) {
      return () => {
        this.$message({
          showClose: true,
          message: msg,
          type: "success",
        });
      };
    },
    onError(msg) {
      return (err) => {
        this.$message({
          showClose: true,
          message: msg,
          type: "error",
        });
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.motion-schedules-setting {
  .delete-schedule-icon {
    cursor: pointer;
  }
  .active-icon__color {
    color: transparentize($--color-fun-green, 0.5);
  }
  .inactive-icon__color {
    color: transparentize($--color-milano-red, 0.5);
  }
  .time-range__column {
    > span {
      display: block;
      small {
        font-weight: bold;
        color: $--color-dusty-gray;
      }
      span {
        float: right;
      }
    }
  }
}
</style>
